export enum ProvisionsFrequencyUnit {
    DIA = 'día',
    MES = 'mes',
    SEMANA = 'semana',
    // QUINCENA = 'quincena',
    // ANIO = 'año',
}
